const Url = require('./../class/url');
const { getEnvironment } = require('./environment');
const environment = getEnvironment();
const url = new Url(environment);

module.exports = url;